import {useAppSelector, useAppDispatch} from '../../../store/hooks.ts'
import {selectConfirmDialog} from '../../../store/ui/uiSelectors.ts'
import {closeConfirmDialog} from '../../../store/ui/uiSlice.ts'
import ConfirmDialog from './ConfirmDialog.tsx'

const ConfirmDialogContainer = () => {
    const dispatch = useAppDispatch()
    const confirmDialog = useAppSelector(selectConfirmDialog)

    const handleConfirm = () => {
        if (confirmDialog.confirmButtonAction) {
            confirmDialog.confirmButtonAction()
        }
        dispatch(closeConfirmDialog())
    }

    const handleClose = () => {
        dispatch(closeConfirmDialog())
    }

    return (
        <ConfirmDialog
            isOpen={confirmDialog.isOpen}
            title={confirmDialog.title}
            text={confirmDialog.text}
            confirmButtonTitle={confirmDialog.confirmButtonTitle}
            onConfirm={handleConfirm}
            onClose={handleClose}
        />
    )
}

export default ConfirmDialogContainer
